import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Template } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const listSignatureTemplates = (
  constructGet: ConstructGet,
  envelopeId: string,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<Template[]> | undefined> =>
  constructGet<NonPaginatedResponse<Template[]>>(
    `${SIGNATURE_BASE_PATH}/envelope/${envelopeId}/templates`,
    { params },
    { transformerSet: TransformerSet.PreserveKeys },
  );
